import { IProduct } from '@/types/types';

export const getUniqueCategories = (
  productList: IProduct[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allowedSlugs: string | any[],
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const uniqueCategories: any = [];

  productList.flatMap(item => {
    const { categories } = item;

    const categoryData = categories?.nodes.filter(category =>
      allowedSlugs.includes(category.translation.slug),
    );

    categoryData.forEach(category => {
      if (
        !uniqueCategories.find(
          (cat: { translation: { slug: string } }) =>
            cat.translation.slug === category.translation.slug,
        )
      ) {
        uniqueCategories.push(category);
      }
    });
  });

  return uniqueCategories;
};
